export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-film-line', description: '院线大片、经典佳作、最新上映电影一网打尽' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line', description: '国产剧、韩剧、美剧、日剧等热门电视剧全集' },
  { slug: 'anime', name: '动漫', icon: 'ri-rocket-line', description: '日漫、国漫、剧场版动画高清在线观看' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line', description: '热门综艺节目、真人秀、脱口秀全集在线' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line', description: '自然、历史、科技、人文纪录片精选' },
];

export interface MovieItem {
  id: number;
  title: string;
  subtitle: string;
  category: string;
  year: number;
  rating: number;
  quality: string;
  tags: string[];
  coverImage: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  releaseDate: string;
  updateInfo: string;
  playCount: string;
  content: string;
  stills: string[];
}

export const movies: MovieItem[] = [
  {
    id: 1,
    title: '流浪地球3',
    subtitle: 'The Wandering Earth 3',
    category: 'movie',
    year: 2026,
    rating: 9.2,
    quality: '4K',
    tags: ['科幻', '灾难', '国产大片'],
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20Earth%20in%20space%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20orange%20and%20black%20color%20scheme%2C%20clean%20simple%20background%2C%20movie%20poster%20style&width=600&height=800&seq=movie-cover-01&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，年轻一代挺身而出，展开一场争分夺秒的生死之战。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    region: '中国大陆',
    duration: '173分钟',
    releaseDate: '2026-02-10',
    updateInfo: '2026-08-03 更新',
    playCount: '2.8亿',
    content: '《流浪地球3》延续了前作的故事，讲述了人类在推动地球逃离太阳系的过程中面临的新挑战。随着地球逐渐远离太阳，地表温度持续下降，人类在地下城中的生活也面临着前所未有的危机。年轻一代的科学家和工程师们必须在有限的时间内解决推进器故障的危机，同时还要应对外部未知力量的威胁。影片以宏大的宇宙视角和细腻的人物刻画，展现了中国科幻电影的工业水准和人文关怀。',
    stills: [
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20scene%20with%20massive%20space%20engines%20on%20Earth%20surface%2C%20epic%20scale%2C%20dramatic%20orange%20lighting%2C%20futuristic%20technology%2C%20movie%20still%20photography&width=1200&height=675&seq=movie-still-01-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Futuristic%20underground%20city%20with%20neon%20lights%20and%20crowded%20streets%2C%20sci-fi%20aesthetic%2C%20warm%20atmosphere%2C%20detailed%20environment%2C%20cinematic%20photography&width=1200&height=675&seq=movie-still-01-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Astronaut%20floating%20in%20deep%20space%20with%20distant%20stars%2C%20dramatic%20lighting%2C%20epic%20composition%2C%20sci-fi%20movie%20aesthetic%2C%20professional%20cinematography&width=1200&height=675&seq=movie-still-01-03&orientation=landscape',
    ],
  },
  {
    id: 2,
    title: '长安三万里·续',
    subtitle: 'Chang An 2',
    category: 'anime',
    year: 2026,
    rating: 9.5,
    quality: '蓝光',
    tags: ['动画', '历史', '国漫'],
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animation%20poster%20featuring%20ancient%20Tang%20Dynasty%20palace%20and%20poets%2C%20traditional%20ink%20painting%20style%2C%20elegant%20warm%20golden%20tones%2C%20clean%20composition&width=600&height=800&seq=movie-cover-02&orientation=portrait',
    description: '以盛唐为背景，讲述李白、杜甫等伟大诗人的传奇人生与不朽诗篇。续集继续探索大唐盛世的文化繁荣与诗人的精神世界。',
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    region: '中国大陆',
    duration: '168分钟',
    releaseDate: '2026-07-15',
    updateInfo: '2026-08-02 更新',
    playCount: '3.1亿',
    content: '《长安三万里·续》延续了第一部的叙事风格，将镜头从李白转向了杜甫的传奇一生。影片以安史之乱为背景，通过杜甫的视角，展现了大唐由盛转衰的历史巨变中，一位伟大诗人的心路历程。精美的画面和动人的配乐，将唐诗的魅力与动画艺术完美融合，被誉为国漫的又一巅峰之作。',
    stills: [
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20at%20sunset%20with%20traditional%20architecture%2C%20warm%20golden%20light%2C%20poetic%20atmosphere%2C%20animation%20movie%20style%2C%20beautiful%20composition&width=1200&height=675&seq=movie-still-02-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20poet%20writing%20calligraphy%20in%20a%20bamboo%20grove%2C%20traditional%20ink%20painting%20aesthetic%2C%20soft%20mountain%20mist%2C%20elegant%20composition&width=1200&height=675&seq=movie-still-02-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20during%20festival%20with%20lanterns%20and%20crowds%2C%20Tang%20Dynasty%20style%2C%20vibrant%20warm%20colors%2C%20animation%20movie%20aesthetic&width=1200&height=675&seq=movie-still-02-03&orientation=landscape',
    ],
  },
  {
    id: 3,
    title: '深海奇缘',
    subtitle: 'Deep Sea Fantasy',
    category: 'movie',
    year: 2026,
    rating: 8.9,
    quality: '4K',
    tags: ['奇幻', '冒险', '特效大片'],
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20underwater%20fantasy%20movie%20poster%20with%20bioluminescent%20creatures%20and%20deep%20ocean%20scene%2C%20magical%20blue-green%20lighting%2C%20cinematic%20and%20clean%20composition&width=600&height=800&seq=movie-cover-03&orientation=portrait',
    description: '一位海洋生物学家在深海探险中发现了一个神秘的水下文明，展开了一段惊心动魄的奇幻冒险之旅。',
    director: '陈思诚',
    actors: ['黄渤', '周冬雨', '张译'],
    region: '中国大陆',
    duration: '145分钟',
    releaseDate: '2026-06-20',
    updateInfo: '2026-08-01 更新',
    playCount: '1.6亿',
    content: '《深海奇缘》讲述了一位执着的海洋生物学家在深海探测中偶然发现了一个隐藏在万米海底的神秘文明。随着探索的深入，他逐渐揭开了这个文明背后关于人类起源的惊人秘密。影片采用了世界顶级的视觉效果技术，将奇幻的海底世界刻画得栩栩如生，带给观众震撼的视觉体验。',
    stills: [
      'https://readdy.ai/api/search-image?query=Deep%20ocean%20with%20glowing%20bioluminescent%20creatures%2C%20magical%20underwater%20world%2C%20ethereal%20blue%20lighting%2C%20fantasy%20movie%20aesthetic&width=1200&height=675&seq=movie-still-03-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Underwater%20ancient%20ruins%20with%20mysterious%20carvings%2C%20deep%20ocean%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20photography&width=1200&height=675&seq=movie-still-03-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Submarine%20approaching%20giant%20underwater%20city%20dome%2C%20futuristic%20and%20ancient%20mix%2C%20dramatic%20ocean%20lighting%2C%20cinematic%20composition&width=1200&height=675&seq=movie-still-03-03&orientation=landscape',
    ],
  },
  {
    id: 4,
    title: '繁花似锦',
    subtitle: 'Blooming Prosperity',
    category: 'tv',
    year: 2026,
    rating: 9.3,
    quality: '1080P',
    tags: ['都市', '商战', '年代剧'],
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20poster%20with%20Shanghai%20cityscape%20and%20fashionable%20people%2C%201990s%20aesthetic%2C%20warm%20nostalgic%20tones%2C%20clean%20composition&width=600&height=800&seq=movie-cover-04&orientation=portrait',
    description: '以上海为背景，讲述了几位年轻人在改革开放浪潮中的奋斗与成长，展现了那个激情燃烧的年代。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣'],
    region: '中国大陆',
    duration: '45分钟/集',
    releaseDate: '2026-05-01',
    updateInfo: '2026-08-03 更新至36集',
    playCount: '5.2亿',
    content: '《繁花似锦》是王家卫导演的首部电视剧作品，以上世纪九十年代的上海为背景，通过细腻的镜头语言和独特的叙事风格，讲述了阿宝等人在时代浪潮中的浮沉人生。剧中不仅有扣人心弦的商战情节，更有令人动容的情感故事，被誉为近年来最具艺术价值的国产电视剧。',
    stills: [
      'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20with%20neon%20lights%20and%20vintage%20cars%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20tones%2C%20period%20drama%20aesthetic&width=1200&height=675&seq=movie-still-04-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20restaurant%20interior%20with%20people%20dining%2C%201990s%20Shanghai%20style%2C%20warm%20lighting%2C%20cinematic%20photography&width=1200&height=675&seq=movie-still-04-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Shanghai%20Bund%20at%20night%20with%20illuminated%20buildings%2C%20period%20drama%20style%2C%20nostalgic%20romantic%20atmosphere&width=1200&height=675&seq=movie-still-04-03&orientation=landscape',
    ],
  },
  {
    id: 5,
    title: '星域传说',
    subtitle: 'Star Realm Legend',
    category: 'anime',
    year: 2026,
    rating: 9.0,
    quality: '4K',
    tags: ['科幻', '机甲', '国漫'],
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20mecha%20anime%20poster%20with%20giant%20robot%20and%20space%20battle%2C%20dynamic%20composition%2C%20red%20and%20black%20color%20scheme%2C%20clean%20background&width=600&height=800&seq=movie-cover-05&orientation=portrait',
    description: '在未来星际时代，人类驾驶巨型机甲与外星文明展开激烈的星际战争，少年驾驶传说中的机甲踏上拯救人类的征程。',
    director: '林魂',
    actors: ['赵路', '沈达威', '杨梦露'],
    region: '中国大陆',
    duration: '24分钟/集',
    releaseDate: '2026-04-10',
    updateInfo: '2026-08-03 更新至48集',
    playCount: '2.3亿',
    content: '《星域传说》讲述了在未来星际殖民时代，人类联邦与神秘外星种族"虚灵"之间的史诗级战争。少年林辰在一次意外中激活了传说中的古代机甲"星渊"，从此踏上了拯救人类文明的征途。本作以其精良的3D动画制作和宏大的世界观设定，成为了国产科幻动画的标杆之作。',
    stills: [
      'https://readdy.ai/api/search-image?query=Giant%20mecha%20robot%20battle%20in%20space%20with%20laser%20beams%2C%20futuristic%20sci-fi%2C%20dynamic%20action%20scene%2C%20anime%20style&width=1200&height=675&seq=movie-still-05-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20bridge%20with%20holographic%20displays%2C%20sci-fi%20interior%2C%20blue%20and%20white%20lighting%2C%20anime%20aesthetic&width=1200&height=675&seq=movie-still-05-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Alien%20planet%20landscape%20with%20twin%20suns%20and%20purple%20vegetation%2C%20sci-fi%20environment%2C%20cinematic%20wide%20shot&width=1200&height=675&seq=movie-still-05-03&orientation=landscape',
    ],
  },
  {
    id: 6,
    title: '笑傲江湖之东方不败',
    subtitle: 'Swordsman Reborn',
    category: 'movie',
    year: 2026,
    rating: 8.7,
    quality: '蓝光',
    tags: ['武侠', '动作', '经典翻拍'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20movie%20poster%20with%20swordsman%20in%20red%20robe%20on%20mountain%20peak%2C%20dramatic%20composition%2C%20traditional%20Chinese%20painting%20style%2C%20clean%20background&width=600&height=800&seq=movie-cover-06&orientation=portrait',
    description: '改编自金庸经典武侠小说，讲述了令狐冲与东方不败之间的恩怨情仇，江湖风云再起，剑指苍穹。',
    director: '徐克',
    actors: ['肖战', '倪妮', '张震'],
    region: '中国香港',
    duration: '155分钟',
    releaseDate: '2026-07-28',
    updateInfo: '2026-08-02 更新',
    playCount: '2.1亿',
    content: '徐克导演再次操刀金庸武侠经典，以现代化的拍摄手法重新演绎《笑傲江湖》。影片以东方不败为核心视角，讲述了这位江湖传奇人物的崛起与陨落。精美的武打设计和震撼的视觉效果，为观众呈现了一个瑰丽壮阔的武侠世界。肖战的令狐冲与倪妮的东方不败，两人的化学反应令人惊艳。',
    stills: [
      'https://readdy.ai/api/search-image?query=Chinese%20swordsman%20fighting%20on%20bamboo%20forest%20with%20flowing%20red%20fabric%2C%20martial%20arts%20movie%2C%20dramatic%20lighting&width=1200&height=675&seq=movie-still-06-01&orientation=landscape',
      'https://readdy.ai/api/search-image?width=1200&height=675&seq=movie-still-06-02&orientation=landscape&query=Ancient%20Chinese%20mountain%20temple%20in%20mist%2C%00martial%20arts%20film%20setting%2C%20atmospheric%20fog%2C%20cinematic',
      'https://readdy.ai/api/search-image?query=Epic%20sword%20fight%20at%20sunset%20on%20cliff%20edge%2C%20Chinese%20wuxia%20style%2C%20golden%20hour%20lighting%2C%20dramatic%20composition&width=1200&height=675&seq=movie-still-06-03&orientation=landscape',
    ],
  },
  {
    id: 7,
    title: '极限挑战·第十季',
    subtitle: 'Go Fighting S10',
    category: 'variety',
    year: 2026,
    rating: 8.5,
    quality: '1080P',
    tags: ['真人秀', '搞笑', '竞技'],
    coverImage: 'https://readdy.ai/api/search-image?query=Fun%20Chinese%20variety%20show%20poster%20with%20six%20celebrities%20in%20colorful%20outfits%2C%20playful%20atmosphere%2C%20bright%20vibrant%20colors%2C%20clean%20composition&width=600&height=800&seq=movie-cover-07&orientation=portrait',
    description: '国内顶级真人秀节目第十季回归，六位固定成员再次集结，展开一系列令人捧腹的极限挑战任务。',
    director: '严敏',
    actors: ['黄渤', '孙红雷', '黄磊', '罗志祥', '王迅', '张艺兴'],
    region: '中国大陆',
    duration: '90分钟/期',
    releaseDate: '2026-06-15',
    updateInfo: '2026-08-03 更新至第8期',
    playCount: '4.5亿',
    content: '《极限挑战》第十季强势回归，"极限男人帮"原班人马再度集结。本季节目在保留经典游戏模式的基础上，融入了更多社会热点话题和公益元素。从城市街头到乡村田野，六位成员将继续用欢笑和泪水为观众带来温暖与感动。',
    stills: [
      'https://readdy.ai/api/search-image?query=Group%20of%20Chinese%20celebrities%20playing%20outdoor%20games%2C%20sunny%20day%2C%20laughing%20and%20running%2C%20variety%20show%20style&width=1200&height=675&seq=movie-still-07-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20city%20street%20with%20celebrities%20doing%20challenge%20tasks%2C%20crowd%20watching%2C%20vibrant%20urban%20atmosphere&width=1200&height=675&seq=movie-still-07-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20countryside%20with%20rice%20fields%2C%20people%20playing%20games%2C%20warm%20sunlight%2C%20variety%20show%20photography&width=1200&height=675&seq=movie-still-07-03&orientation=landscape',
    ],
  },
  {
    id: 8,
    title: '地球脉动·中国篇',
    subtitle: 'Planet Earth China',
    category: 'documentary',
    year: 2026,
    rating: 9.8,
    quality: '4K',
    tags: ['自然', '纪录片', 'BBC级别'],
    coverImage: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20poster%20with%20Chinese%20mountain%20landscape%20and%20wildlife%2C%20panda%20and%20snow%20leopard%2C%20cinematic%20epic%20composition&width=600&height=800&seq=movie-cover-08&orientation=portrait',
    description: '历时五年拍摄，横跨中国全境的史诗级自然纪录片，展现了中国大地上最壮观的自然奇观和珍稀野生动物。',
    director: 'BBC Studios',
    actors: ['刘琮（旁白）'],
    region: '中国/英国',
    duration: '60分钟/集',
    releaseDate: '2026-03-20',
    updateInfo: '2026-08-01 更新至第6集',
    playCount: '1.8亿',
    content: '《地球脉动·中国篇》是BBC《地球脉动》系列首次以单个国家为主题打造的纪录片。制作团队历时五年，深入中国最偏远的地区，从青藏高原到南海珊瑚礁，从东北雪原到云南热带雨林，用4K超高清镜头记录了中国大地上最震撼人心的自然奇观和野生动物故事。',
    stills: [
      'https://readdy.ai/api/search-image?query=Chinese%20snow%20leopard%20on%20Tibetan%20plateau%20mountain%2C%20snow%20covered%20rocks%2C%20epic%20wildlife%20photography%2C%20dramatic%20landscape&width=1200&height=675&seq=movie-still-08-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Giant%20panda%20in%20bamboo%20forest%20of%20Sichuan%20China%2C%20misty%20morning%20light%2C%20beautiful%20nature%20documentary%20style&width=1200&height=675&seq=movie-still-08-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Zhangjiajie%20sandstone%20pillars%20in%20mist%2C%20Avatar%20mountains%20China%2C%20aerial%20view%2C%20cinematic%20epic%20landscape%20photography&width=1200&height=675&seq=movie-still-08-03&orientation=landscape',
    ],
  },
  {
    id: 9,
    title: '暗夜追踪',
    subtitle: 'Night Pursuit',
    category: 'tv',
    year: 2026,
    rating: 8.8,
    quality: '4K',
    tags: ['悬疑', '刑侦', '网剧'],
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20crime%20thriller%20poster%20with%20detective%20in%20rainy%20city%20street%2C%20noir%20style%2C%20moody%20atmosphere%2C%20clean%20simple%20composition&width=600&height=800&seq=movie-cover-09&orientation=portrait',
    description: '一位退休刑警被迫重返一线，追查一系列看似毫无关联却暗藏玄机的连环案件，揭开尘封多年的惊天秘密。',
    director: '五百',
    actors: ['段奕宏', '谭卓', '王景春'],
    region: '中国大陆',
    duration: '50分钟/集',
    releaseDate: '2026-07-08',
    updateInfo: '2026-08-03 更新至18集',
    playCount: '3.6亿',
    content: '《暗夜追踪》是一部高水准的国产刑侦悬疑剧。段奕宏饰演的退休刑警林墨，因为一桩离奇的案件被迫重返警队。在追查过程中，他逐渐发现这些案件背后隐藏着一个横跨二十年的惊天阴谋。紧凑的剧情、精湛的演技和电影级的制作水准，使其成为今年最受好评的悬疑剧集。',
    stills: [
      'https://readdy.ai/api/search-image?query=Detective%20in%20rainy%20alley%20at%20night%2C%20noir%20crime%20scene%2C%20neon%20reflections%2C%20moody%20cinematic%20lighting&width=1200&height=675&seq=movie-still-09-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Police%20investigation%20room%20with%20evidence%20board%2C%20dark%20atmosphere%2C%20red%20strings%20connecting%20photos%2C%20crime%20drama%20style&width=1200&height=675&seq=movie-still-09-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Abandoned%20factory%20at%20night%20with%20flashlight%20beams%2C%20crime%20scene%20investigation%2C%20suspenseful%20atmosphere%2C%20cinematic&width=1200&height=675&seq=movie-still-09-03&orientation=landscape',
    ],
  },
  {
    id: 10,
    title: '他来自未来',
    subtitle: 'He Comes From Future',
    category: 'tv',
    year: 2026,
    rating: 8.6,
    quality: '1080P',
    tags: ['爱情', '奇幻', '甜宠'],
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20drama%20poster%20with%20couple%20under%20starry%20sky%2C%20warm%20dreamy%20atmosphere%2C%20soft%20pink%20and%20purple%20tones%2C%20clean%20composition&width=600&height=800&seq=movie-cover-10&orientation=portrait',
    description: '一位来自2050年的AI工程师意外穿越到2026年，与一位古灵精怪的都市女孩相遇，上演了一场跨时空的浪漫爱情故事。',
    director: '陈畅',
    actors: ['杨洋', '赵露思', '王安宇'],
    region: '中国大陆',
    duration: '45分钟/集',
    releaseDate: '2026-07-20',
    updateInfo: '2026-08-03 更新至24集',
    playCount: '2.7亿',
    content: '《他来自未来》是一部融合了科幻、爱情与喜剧元素的都市奇幻剧。来自2050年的AI工程师苏铭意外穿越到2026年，遇到了古灵精怪的短视频创作者林小棠。一个来自未来、一个活在当下，两个世界的碰撞带来了无数笑料与感动。轻松治愈的剧情加上高颜值的演员阵容，让这部剧成为了今年夏天最受欢迎的甜宠剧。',
    stills: [
      'https://readdy.ai/api/search-image?query=Modern%20city%20rooftop%20at%20sunset%20with%20young%20couple%2C%20romantic%20atmosphere%2C%20warm%20golden%20light%2C%20Korean%20drama%20style&width=1200&height=675&seq=movie-still-10-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cozy%20coffee%20shop%20interior%20with%20warm%20lighting%2C%20young%20couple%20talking%2C%20romantic%20comedy%20aesthetic&width=1200&height=675&seq=movie-still-10-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Futuristic%20holographic%20interface%20in%20modern%20apartment%2C%20sci-fi%20elements%20blend%20with%20daily%20life%2C%20warm%20cinematic%20lighting&width=1200&height=675&seq=movie-still-10-03&orientation=landscape',
    ],
  },
  {
    id: 11,
    title: '明日之战',
    subtitle: 'Tomorrow War',
    category: 'movie',
    year: 2026,
    rating: 8.4,
    quality: '4K',
    tags: ['动作', '科幻', '好莱坞'],
    coverImage: 'https://readdy.ai/api/search-image?query=Action%20sci-fi%20movie%20poster%20with%20soldier%20in%20futuristic%20armor%2C%20explosion%20background%2C%20epic%20scale%2C%20clean%20dramatic%20composition&width=600&height=800&seq=movie-cover-11&orientation=portrait',
    description: '未来世界遭遇外星入侵，人类组建精英战队穿越时空回到现在，试图在灾难发生之前阻止这场浩劫。',
    director: '克里斯·麦凯',
    actors: ['克里斯·帕拉特', '伊冯娜·斯特拉霍夫斯基'],
    region: '美国',
    duration: '138分钟',
    releaseDate: '2026-06-10',
    updateInfo: '2026-08-02 更新',
    playCount: '1.9亿',
    content: '在不久的将来，人类遭遇了一场来自外星的毁灭性入侵。为了改变命运，科学家们开发出了时空穿越技术，派遣精英战士回到现在，试图在入侵开始之前阻止这场灾难。这部电影以其震撼的视觉效果和紧凑的叙事节奏，成为了今年暑期档最受瞩目的好莱坞大片之一。',
    stills: [
      'https://readdy.ai/api/search-image?query=Futuristic%20battlefield%20with%20soldiers%20fighting%20aliens%2C%20explosions%20and%20laser%20fire%2C%20epic%20sci-fi%20war%20scene&width=1200&height=675&seq=movie-still-11-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Time%20portal%20opening%20in%20modern%20city%20street%2C%20sci-fi%20visual%20effects%2C%20dramatic%20lighting%2C%20cinematic&width=1200&height=675&seq=movie-still-11-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Military%20base%20with%20futuristic%20weapons%20and%20vehicles%2C%20sci-fi%20setting%2C%20dramatic%20storm%20sky%2C%20action%20movie%20aesthetic&width=1200&height=675&seq=movie-still-11-03&orientation=landscape',
    ],
  },
  {
    id: 12,
    title: '舌尖上的中国·第四季',
    subtitle: 'A Bite of China S4',
    category: 'documentary',
    year: 2026,
    rating: 9.6,
    quality: '4K',
    tags: ['美食', '文化', '纪录片'],
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20food%20documentary%20poster%20with%20steaming%20dumplings%20and%20traditional%20kitchen%2C%20warm%20appetizing%20colors%2C%20clean%20elegant%20composition&width=600&height=800&seq=movie-cover-12&orientation=portrait',
    description: '时隔多年，这部被誉为中国美食纪录片的巅峰之作再度回归，带你领略大江南北的人间至味与烟火气息。',
    director: '陈晓卿',
    actors: ['李立宏（旁白）'],
    region: '中国大陆',
    duration: '50分钟/集',
    releaseDate: '2026-04-25',
    updateInfo: '2026-08-01 更新至第8集',
    playCount: '4.0亿',
    content: '《舌尖上的中国》第四季时隔八年重磅回归。本季以"人间烟火"为主题，深入中国各地的大街小巷，从北上广深的米其林餐厅到偏远山村的农家灶台，用镜头记录下这个时代最真实的味道。每一道美食背后，都承载着一个关于人、关于家、关于传承的动人故事。',
    stills: [
      'https://readdy.ai/api/search-image?query=Chinese%20chef%20cooking%20in%20traditional%20kitchen%20with%20steam%20and%20fire%2C%20warm%20atmosphere%2C%20food%20documentary%20style&width=1200&height=675&seq=movie-still-12-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20family%20dinner%20table%20with%20many%20dishes%2C%20festive%20atmosphere%2C%20warm%20lighting%2C%20food%20photography&width=1200&height=675&seq=movie-still-12-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Street%20food%20market%20in%20China%20at%20night%2C%20smoke%20and%20steam%2C%20colorful%20neon%20signs%2C%20bustling%20atmosphere&width=1200&height=675&seq=movie-still-12-03&orientation=landscape',
    ],
  },
];

export const heroMovies = [movies[0], movies[1], movies[3]];

export const hotMovies = [movies[0], movies[3], movies[2], movies[5], movies[11], movies[8]];

export const latestMovies = [movies[4], movies[9], movies[1], movies[6], movies[11], movies[10]];

export const topRatedMovies = [movies[7], movies[1], movies[3], movies[0], movies[11], movies[2]];